import { useEffect } from 'react';
import { useInternacionesIniciadoAutorizadoData } from '../hooks';
import { IniciadoAutorizadoTotalesSection } from './IniciadoAutorizadoTotalesSection';
import { IniciadoAutorizadoSection } from './IniciadoAutorizadoSection';

const initData = {
  // idDivision: 5,
  // idTipoCobertura: 166,
};

export const InternacionesTramitesIniciadoAutorizado = () => {
  const { getInternacionesTramitesAnualList, getInternacionesTramitesMensualList } =
    useInternacionesIniciadoAutorizadoData({
      ...initData,
    });

  useEffect(() => {
    getInternacionesTramitesAnualList();
    getInternacionesTramitesMensualList();
  }, []);

  return (
    <>
      <IniciadoAutorizadoTotalesSection />
      <IniciadoAutorizadoSection />
    </>
  );
};
